import dayjs from 'dayjs';
import { IComparator } from '@infodata-group/inf-commons';

export class Period implements IComparator {
  public num: number;
  public dateStart: Date;
  public dateStartLabel: string;
  public dateEnd: Date;
  public dateEndLabel: string;
  public closure: { id: string; label: string; remark: string };

  toString(): string {
    return `${this.num} - ${this.dateStartLabel} - ${this.dateEndLabel}`;
  }

  serialize(): any {
    return {
      Num: this.num,
      Closure: this.closure,
      DateBegin: dayjs(this.dateStart).format('DD.MM.YYYY'),
      DateEnd: dayjs(this.dateEnd).format('DD.MM.YYYY'),
    };
  }

  convert(data: any): Period {
    const period = new Period();
    period.num = data.Num;
    period.closure = data.Closure;
    const momentDateStart = dayjs(data.DateBegin, 'DD.MM.YYYY');
    period.dateStart = momentDateStart.toDate();
    period.dateStartLabel = momentDateStart.format('DD/MM/YYYY');
    const momentDateEnd = dayjs(data.DateEnd, 'DD.MM.YYYY');
    period.dateEnd = momentDateEnd.toDate();
    period.dateEndLabel = momentDateEnd.format('DD/MM/YYYY');
    return period;
  }

  compare(comparant: any): number {
    if (typeof comparant === 'string') {
      return this.num.toString().localeCompare(comparant);
    } else {
      return this.num.toString().localeCompare(comparant.num);
    }
  }
}
